import { joiResolver } from '@hookform/resolvers/joi';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { stringToPayloadFormat } from 'web-library';
import { useGetCoordinatorProfile } from '../../../api-refactored/user/useGetCoordinatorProfile';
import { useGetIExamMasterCode } from '../../../api-refactored/user/useGetIExamMasterCode';
import { usePutUpdateCoordinatorProfile } from '../../../api-refactored/user/usePutUpdateCoordinatorProfile';
import { CoordinatorProfileRequest } from '../../../api/user/model';
import CoordinatorProfileDetails from '../../../components/CoordinatorProfileDetails';
import { CoordinatorProfileData } from '../../../models';
import { selectFormEditMode, UpdateFormEdit } from '../../../store/formSlice';
import CompleteProfileDetailsScheme from '../schema/completeProfileDetailsScheme';
import { useWOGAA } from '../../../hooks/wogaa';
// wogaa start and end transaction for coordinator profile update
const CompleteProfileDetailsForm = () => {
  const { data } = useGetCoordinatorProfile();
  const updateCoordinatorProfile = usePutUpdateCoordinatorProfile({
    onSuccess: () => {
      // Pass user uuid as agencyTxnId for WOGAA sentiments tracking
      transactionEnd(data?.uuid);
    },
  });

  const { transactionStart, transactionEnd } = useWOGAA('myexamsseab-6472');

  const update = (formData: CoordinatorProfileData) => {
    if (!data) {
      return;
    }
    const request: CoordinatorProfileRequest = {
      coordinatorName: data.coordinatorName,
      email: data.email,
      dateOfBirth: data.dateOfBirth,
      salutation: formData.salutation,
      designation: formData.designation,
      organisation: data.organisation,
      contactNumber: {
        countryCode: formData.countryCode,
        number: formData.number,
      },
    };
    updateCoordinatorProfile.mutate(request);
    updateFormState();
  };

  const {
    data: dataIEXAM,
    isLoading: isLoadingIEXAM,
    error: errorMasterCode,
    refetch: refetchMasterCode,
  } = useGetIExamMasterCode();

  const form = useForm<CoordinatorProfileData>({
    mode: 'onSubmit',
    resolver: joiResolver(CompleteProfileDetailsScheme),
    defaultValues: data,
  });
  const editMode = useSelector(selectFormEditMode);
  const dispatch = useDispatch();

  const updateFormState = () => {
    if (!editMode) {
      transactionStart();
    }
    dispatch(UpdateFormEdit(!editMode));
  };

  return (
    <form onSubmit={form.handleSubmit(update)}>
      {data && dataIEXAM && (
        <CoordinatorProfileDetails
          data={data}
          isEditable={editMode}
          onEditClick={updateFormState}
          convertedData={stringToPayloadFormat(data ? data.dateOfBirth : '')}
          form={form}
          dataIEXAM={dataIEXAM}
          isLoadingIEXAM={isLoadingIEXAM}
          errorMasterCode={errorMasterCode}
          refetchMasterCode={refetchMasterCode}
          updateCoordinatorProfile={updateCoordinatorProfile}
        />
      )}
    </form>
  );
};

export default CompleteProfileDetailsForm;
